import type { ReactNode } from 'react';
import { cx } from '../internal/cx';

/** Props of {@link Kbd}. */
export interface KbdProps {
  /** The key or chord to show, already written the way the platform spells it (`⌘K`, `Ctrl+K`). */
  children: ReactNode;
  /** Extra utility classes. */
  className?: string;
}

/**
 * A keyboard key, for menu shortcuts and the shortcut help dialog.
 *
 * @example <Kbd>⌘K</Kbd>
 */
export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cx(
        'inline-flex min-w-5 items-center justify-center rounded-xs border border-border-strong',
        'bg-surface-sunken px-1 font-sans text-caption text-text-secondary',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
